module.exports = __webpack_public_path__ + "img/cover.8b1d256d.png";